import * as React from 'react';
import {
  Routes,
  Route,
  Link as LinkRoute,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
} from "react-router-dom";
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
//import Grid from '@mui/material/Grid';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import Tooltip from '@mui/material/Tooltip';

import Toolbar from '@mui/material/Toolbar';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import SaveIcon from '@mui/icons-material/Save';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import { alpha } from '@mui/material/styles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import FilledInput from '@mui/material/FilledInput';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import FormGroup from '@mui/material/FormGroup';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import NativeSelect from '@mui/material/NativeSelect';
import MenuItem from '@mui/material/MenuItem';
import useLocalStorageState from 'use-local-storage-state'

import CircularProgress from '@mui/material/CircularProgress';
import { DataGrid, GridRowsProp, GridColDef,GridRowId,GridToolbar,GridRowSelectionModel, GridRenderCellParams } from '@mui/x-data-grid';

import {useAuth} from '../../context/AuthContext'

import theme from '../../theme';

// import {IVehWarrInfoRow,IVehWarrInfoResponse,IPrAvResponse,IPostWarrClaimResponse,IPostWarrClaimResponseData} from '../PageInterfaces'
import {IVehWarrInfoRow,IVehWarrInfoResponse} from '../PageInterfaces'

import UploadImagesV2 from '../components/UploadImagesv2'

import { returnBasenameUrl } from '../../utils';

import dayjs, { Dayjs } from 'dayjs'
import * as isLeapYear from 'dayjs/plugin/isLeapYear'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField } from '@mui/x-date-pickers/DateField';
import 'dayjs/locale/el';

import classes from '../../components/Cart/cart.module.scss';

import ImageMapper from 'react-img-mapper';
import type { MapArea, RefProperties } from 'react-img-mapper';

import {VehCustInfoContext,IVehCustInfoContextState,initialVehCustInfoContextState} from '../../context/VehCustInfoContext'

type localFieldConfigType = {
    required: boolean,
    datatype: string
}
type VehCustInfoConfigType = {
    maxnumofimagesperdoc: number,
    maxbytesperimage: number,
    allowableimagetypes: string[],
    allowableimageext: string[],
    vin: localFieldConfigType,
    saledate: localFieldConfigType,
    comments: localFieldConfigType,
    custname: localFieldConfigType,
    custaddr: localFieldConfigType,
    custzip: localFieldConfigType,
    custcity: localFieldConfigType,
    custcountry: localFieldConfigType,
    custmobile: localFieldConfigType,
    custemail: localFieldConfigType
}
// type opscodesDataType = {
//     warrops: Array<WarrOpType>,
//     faultypes: Array<OpCodeCategType>,
//     troubles: Array<OpCodeCategType>,
//     reasons: Array<OpCodeCategType>, 
//     warrclaimconfig?: warrclaimconfigType
// }

// type vhcuinfConfigType = {
//     success: boolean,
//     data: VehCustInfoConfigType
// }

// type VehCustInfoResponseType = {
//     fetched: boolean
//     success: boolean    
//     reply?: string
//     totalcount?: number
//     procstep?: number
//     error?: string
//     data?: vhcuinfConfigType
// }
const InitialVehCustInfoCfg: VehCustInfoConfigType =  {
        maxnumofimagesperdoc: 1,
        maxbytesperimage: 4000000,
        allowableimagetypes: ["image/jpeg","image/png"],
        allowableimageext: [".jpg", ".jpeg" , ".png"],
        vin: {"required":true,"datatype":"string"},
        saledate: {"required":true,"datatype":"date"},
        comments: {"required":false,"datatype":"string"},
        custname: {"required":true,"datatype":"string"},
        custaddr: {"required":true,"datatype":"string"},
        custzip: {"required":true,"datatype":"string"},
        custcity: {"required":true,"datatype":"string"},
        custcountry: {"required":false,"datatype":"string"},
        custmobile: {"required":true,"datatype":"string"},
        custemail: {"required":true,"datatype":"string"}
}
export type VehicleCustomerInfoProps = {
  mode: string ; // 'view' | 'edit' | 'create'
  vin?: string;
}
export const newVehicleCustomerInfoPropsExample = {
  mode: 'create'
};
export const viewVehicleCustomerInfoPropsExample = {
  mode: 'listdocs'
};
export const editVehicleCustomerInfoPropsExample = {
  mode: 'edit',
  vin: 'knownvin'
};
const vininfoExample = {
    vehid:0,
    vin:"",
    vehname:"",
    vehname2:"",
    brandid:0,
    modelid:0,
    brandcode:"",
    modelcode:"",
    brandname:"",
    modelname:"",
    vehdocid:0
}
type newVehinfoResponseType = {
  success: boolean,
  error?: string,
  reply?: string,
  totalcount?: number,
  procstep?: number,
  data?: {
    infodocid: number,
    infodoccode: string,
    infodocnumber: number
  },
  request?: Object
};

type ListVehInfoDataResponseType ={
docid:number,
doccode:string,
vin:string,
vinname:string,
docdate:string,
saldate:string,
docfinstate:number,
docfinstname:string,
iscancel:number,
approoved:number,
remarks:string,
comments: string,
custname: string,
custaddr: string,
custzip: string,
custcity: string,
custcountry: string,
custmobile: string,
custemail: string,
attachements: typeof attachementsExample
}

type ListVehCustInfoResponseType = {
success:boolean
reply:string,
totalcount:number,
procstep?:number,
data?:ListVehInfoDataResponseType[],
request?:Object
}

enum VehInfodocFromModeEnum {
  NEW = 1,
  EDIT = 2,
  VIEW = 3
}

// @ts-expect-error
dayjs.extend(isLeapYear) // use plugin
dayjs.locale('el')

const OkMark = styled('span')`
  margin-left: 8px;
  margin-top: 10px;
  color: rgb(125 200 0 / 1);
`;

const steps = [
  'Πλαίσιο',  
  'Στοιχεία Πελάτη',
  'Αποθήκευση', 
  'Επισύναψη φωτό'
];
const stepsmessage = [
  'Εισαγωγή πλαισίου της μοτοσυκλέτας', 
  'Συμπλήρωση Στοιχείων Πελάτη',
  'Αποθήκευση', 
  'Επισύναψη φωτό'
];

function getSessionVehCustInfoData()
{
  const storedState = sessionStorage.getItem(`${process.env.REACT_APP_VEHCUSTINFOSESSKEY}`);
  if (storedState) {
    console.log("==* function getSessionVehicleInfoData returning storedState=",storedState)
    return(JSON.parse(storedState)) as IVehCustInfoContextState;
  }
  else {
    console.log("==* function getSessionVehicleInfoData returning initialVehCustInfoContextState=",initialVehCustInfoContextState)
    return {...initialVehCustInfoContextState,  warrdate: dayjs(new Date()).toJSON() }
  }
}

export const attachementsExample = [
  {
    "file": "https://b2bksrgr.local/api/fupld/warrimages/wcimg-73176-a69bea4ff2712476b2325d4863154abb6d17e123.png",
    "originalfile": "companyLogo.png",
    "posteddatetime": "2026-03-25 hh:mm"
  }
];

const InitialVehCustInfoDoc:ListVehInfoDataResponseType =  {
        docid: 0,
        doccode: "",
        vin: "",
        vinname: "",
        docdate: "",
        saldate: "",
        docfinstate: 0,
        docfinstname: "",
        iscancel: 0,
        approoved: 0,
        remarks: "",
        comments: "",
        custname: "",
        custaddr: "",
        custzip: "",
        custcity: "",
        custcountry: "",
        custmobile: "",
        custemail: "",
        attachements: []
}

type GetVehCustInfoDocResponseType= {
  success: boolean,
  reply?: string,
  totalcount?: number,
  procstep?: number,
  data?: ListVehInfoDataResponseType
}
// Array<typeof InitialVehCustInfoDoc>

type VehicleInfoDocFormProps = {
  mode: VehInfodocFromModeEnum,
  data: ListVehInfoDataResponseType | null,
  cbf: () => void
}

export default function VehicleCustomerInfo(props: VehicleCustomerInfoProps) {

  if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log("====== ********* JS VehicleCustomerInfo=, starts with prop.mode=",props.mode)

  if(props.mode==='create') {
    return(    
      <NewVehicleCustomerInfo {...props} />
    )
  } 
  else if(props.mode==='listdocs') {
    return (
      <ListVehicleCustomerInfo {...props} />
    )
  } 
  else {
    return (<>{`DEBUG TESTS mode=${props.mode}`}</>)
  } 
}


function ListVehicleCustomerInfo(props: VehicleCustomerInfoProps) {
  if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log("====== ********* JS ListVehicleCustomerInfo=, starts with prop.mode=",props.mode)
  let auth = useAuth();
  const [locale, setLocale] = React.useState<string>('el');  
  const [asuinfo, Setasuinfo]=React.useState({
      WEBSERVICE: 0,
      bu: 0,
      buname: "",
      trdr: 0,
      trdbame: "",
      trdbranch: 0,
      trdbrnname: "",
      trdafm: "",
      trdemail: "",
      whs: "",
      accesslevel: 0
  })
  const [isloading, setIsloading] = React.useState(false)
  const [showdetails, setShowdetails]= React.useState(false)
  const [vehinfodoclist, setVehinfodoclist] = React.useState<ListVehInfoDataResponseType[]>([])
  const [selvehinfodoc, setSelvehinfodoc] = React.useState(0)
  const [vehinfodoc, setVehinfodoc] = React.useState<ListVehInfoDataResponseType | null>(null)
  const [fromcdocdate, Setfromcdocdate] = React.useState<Dayjs | null>(dayjs().subtract(3, 'month'))
  const [todocdate, Settodocdate] = React.useState<Dayjs | null>(dayjs())

  function fetchVehInfoDocs() {
    if(auth.userData.success!==true) return
    if(auth.userData.aftersaccesslevel===undefined || auth.userData.aftersaccesslevel===null || auth.userData.aftersaccesslevel<1) {
      console.log('fetchVehInfoDocs fetchVehInfoDocs(), not auth for as access')
      return
    }
    if(`${asuinfo.bu}`!==process.env.REACT_APP_AFTERSBU || asuinfo.trdr<=0 ) {alert('Bad user information');return;}
    if(`${asuinfo.bu}`!==process.env.REACT_APP_AFTERSBU || asuinfo.trdr<=0 ) {alert('Bad user information');return;}

    setIsloading(true);
    let fromdatestr = fromcdocdate ? fromcdocdate.format('YYYYMMDD') : ''
    let todatestr = todocdate ? todocdate.format('YYYYMMDD') : ''
    let usercode = auth.userData.username
        let token = auth.userData.token
        let postdata = {
          service: "getlistofvehinfodocs", 
          usercode: usercode,
          // vin: warrclaimState.vin,
          clientid: token,
          trdr: asuinfo.trdr,
          trdbranch:asuinfo.trdbranch,
          accesslevel: asuinfo.accesslevel,
          userid: auth.userData.userid,
          webservice: asuinfo.WEBSERVICE, 
          bu: asuinfo.bu,
          fromdate: fromdatestr,
          todate: todatestr
        }
        let body = JSON.stringify(postdata)
        const ms = Date.now();
        let basename=returnBasenameUrl()
        let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
          body: body , cache: "no-store"
        })
        .then((response) =>  {
          if (!response.ok) return {} 
          else return response.json()
        })
        .then((data:any) => {
          const isSuccessDocinfoResponse = (data: any): data is GetVehCustInfoDocResponseType =>
                      typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
          if (isSuccessDocinfoResponse(data) && data.success!==true)
          {
            alert('Η εύρεση Εγγράφου Οχήματος απέτυχε.')
          }
          else {
            // console.log("data.hasOwnProperty('totalcount')",data.hasOwnProperty('totalcount'),"typeof data.totalcount",typeof data.totalcount)
            if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && typeof data.data === 'object'){
              if( data.totalcount<=0) {
                alert('Η εύρεση Εγγράφου Οχήματος απέτυχε (query return empty, non existing vin')
              }
              else {
                console.log("fetchVehInfoDocs okey data.data", data.data);
                setVehinfodoclist(data.data || []);
              }
            }
            else {
              alert('Η εύρεση Εγγράφου Οχήματος δεν είχε αποτέλεσμα.')
            }
          }
        })
        .finally(() => {
          setIsloading(false);
        });
  }
  
  const VehDocListColumns : GridColDef[] = [  // , width: 150
        { field: 'docdate',
          type: 'string',
          headerName: 'Ημερομηνία',
          disableReorder: true,
          hideable: false,
          flex:1
        },
        {
          field: 'doccode',
          type: 'string',
          headerName: 'Παραστατικό',
          disableReorder: true,
          hideable: false,
          flex:1
        },
        { field: 'saldate',
        type: 'string',
        headerName: 'Ημ.Πώλησης',
        disableReorder: true,
        hideable: false,
        flex:1
        },
        { field: 'vin',
            type: 'string',
            headerName: 'Πλαίσιο',
            disableReorder: true,
            hideable: false,
            flex:2
        },
        { field: 'vinname',
            type: 'string',
            headerName: 'Περιγραφή',
            disableReorder: true,
            hideable: false,
            flex:2
        },
        {
          field: 'docfinstname',
          type: 'string',
          headerName: 'Κατάσταση',
          disableReorder: true,
          hideable: false,
          flex:1,
          //renderCell: (params: GridRenderCellParams<any, number>) => (
          //  <strong>
          //      {params.value ? params.value.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) : params.value }
          //   </strong>
          //  ),
        },
        {
            field: 'docfinstate',
            //  ['none', 'submitted', 'checked', 'approved','canceled','completed','pending']
            //  100	ΑΔΙΑΦΟΡΟ 101	ΥΠΟΒΛΗΘΗΚΕ 102	ΕΛΕΓΧΘΗΚΕ 103	ΕΓΚΡΙΘΗΚΕ 104	ΑΚΥΡΩΘΗΚΕ 105	ΟΛΟΚΛΗΡΩΘΗΚΕ 111	ΕΚΚΡΕΜΟΤΗΤΕΣ
            valueGetter: (value, row:ListVehInfoDataResponseType) => {
              // if(row.wclaimstate===100) return 'none'
              // else if(row.wclaimstate===101) return 'submitted'
              // else if(row.wclaimstate===102) return 'checked'
              // else if(row.wclaimstate===103) return 'approved' 
              // else if(row.wclaimstate===104) return 'canceled'
              // else if(row.wclaimstate===111) return 'pending'
              // else return `${row.wclaimstatus || ''}`;
              return 'none'
            },
            headerName: 'Status',
            // renderCell: claimRenderStatus,
            // valueOptions: CLAIM_STATUS_OPTIONS,
            width: 150,
            editable: false,
          },
        {
          field: 'docid',
          type: 'number',
          headerName: ' X ',
          disableReorder: true,
          hideable: false,
          flex:1,
          renderCell: (params: GridRenderCellParams<any, number>) => (
            <strong>
                <IconButton color="primary" aria-label="zoom to order" tabIndex={params.hasFocus ? 0 : -1}
                  onClick={(e)=>{ handleZoomToOrderRow(e, params.row) }}>
                  <ZoomInIcon />
                </IconButton>
              </strong>
            ),
        }
  ]

  type Order = 'asc' | 'desc';

  function getRowId(row:ListVehInfoDataResponseType) {
      return row.docid;
  }

  //  function retrieveVehInfoDocDetails(rowboj:ListVehInfoDataResponseType){

  //     // setWarrclaim(rowboj)
  //     // setWarrclaimdocdet({})
  //     if(auth.userData.success!==true) return
  //       if(auth.userData.aftersaccesslevel===undefined || auth.userData.aftersaccesslevel===null || auth.userData.aftersaccesslevel<1) {
  //       console.log('retrieveVehInfoDocDetails(), not auth for as access')
  //       return
  //     }
  //     if(`${asuinfo.bu}`!==process.env.REACT_APP_AFTERSBU || asuinfo.trdr<=0 ) {alert('Bad user information');return;}
  //     if(`${asuinfo.bu}`!==process.env.REACT_APP_AFTERSBU || asuinfo.trdr<=0 ) {alert('Bad user information');return;}
  //     setIsloading(true);
  //     let docid = rowboj.docid;
  //     let vin = rowboj.vin;
  //     let usercode = auth.userData.username
  //     let token = auth.userData.token
  //     let postdata = {
  //         service: "getvinfordocinfo", 
  //         usercode: usercode,
  //         vin: vin,
  //         clientid: token,
  //         trdr: asuinfo.trdr,
  //         trdbranch:asuinfo.trdbranch,
  //         accesslevel: asuinfo.accesslevel,
  //         userid: auth.userData.userid,
  //         webservice: asuinfo.WEBSERVICE, 
  //         bu: asuinfo.bu,
  //         docid: docid
  //       }
  //     let body = JSON.stringify(postdata)
  //     const ms = Date.now();
  //     let basename=returnBasenameUrl()
  //     let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
  //       fetch(url, {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
  //         body: body , cache: "no-store"
  //       })
  //       .then((response) =>  {
  //         if (!response.ok) return {} 
  //         else return response.json()
  //       })
  //       .then((data:any) => {
  //         const isSuccessVehInfoDocResponse = (data: any): data is GetVehCustInfoDocResponseType =>
  //               typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
  //         if (isSuccessVehInfoDocResponse(data) && data.success!==true)
  //         {
  //           alert('Η εύρεση του Εγγράφου Οχήματος απέτυχε.')  
  //           // setWarrclaim(rowboj)
  //           setVehinfodoc(InitialVehCustInfoDoc)
  //         }
  //         else {
  //           // console.log("data.hasOwnProperty('totalcount')",data.hasOwnProperty('totalcount'),"typeof data.totalcount",typeof data.totalcount)
  //           if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && typeof data.data === 'object'){
  //             if( data.totalcount<=0) {
  //               alert('Η εύρεση του Εγγράφου Οχήματος απέτυχε (query return empty, non existing vin')
  //             }
  //             else {
  //               // setWarrclaims(data.data || []);
  //               console.log("okey data.data", data.data);
  //               setVehinfodoc(data.data[0] || {});
  //               setShowdetails(true);
  //             }
  //           }
  //           else {
  //             setVehinfodoc(InitialVehCustInfoDoc)
  //             console.log("no data data.data", data.data);
  //             alert('Η εύρεση του Εγγράφου Οχήματος δεν είχε αποτέλεσμα.')
  //           }
  //         }
  //       })
  //       .finally(() => {
  //         setIsloading(false);
  //       });

  //     }

    function handleCloseDetails()
    {
        setVehinfodoc(null)
        setShowdetails(false)
    }


    function handleZoomToOrderRow(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, rowboj:ListVehInfoDataResponseType){
        // retrieveVehInfoDocDetails(rowboj)
        setVehinfodoc(rowboj)
        setShowdetails(true)
    }
  React.useEffect(()=>{
    console.log('=JS ListVehicleCustomerInfo=, useeffect[] called...')
    auth.userData.userinfo?.bus?.forEach( (obu:any) =>{
        console.log('=JS ListVehicleCustomerInfo=, Setasuinfo useeffect[] obu=',obu)
        if(`${obu.bu}`===process.env.REACT_APP_AFTERSBU) {
          Setasuinfo({
            WEBSERVICE: obu.WEBSERVICE,
            bu:  obu.bu,
            buname:  obu.buname,
            trdr:  obu.trdr,
            trdbame:  obu.trdbame,
            trdbranch: obu.trdbranch,
            trdbrnname:  obu.trdbrnname,
            trdafm:  obu.trdafm,
            trdemail:  obu.trdemail,
            whs:  obu.whs,
            accesslevel:  obu.accesslevel
          })         
        }
    })

  },[])


console.log("render ListVehicleCustomerInfo, showdetails=",showdetails,"vehinfodoclist",vehinfodoclist)

  return(<>

    {showdetails === false && <section>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
        <DatePicker
            label="Από Ημερομηνία"
            value={fromcdocdate}
            onChange={(newValue) => Setfromcdocdate(newValue)}
          />
          <DatePicker
            label="Έως Ημερομηνία"
            value={todocdate}
            onChange={(newValue) => Settodocdate(newValue)}
          />
        </LocalizationProvider>
         <Button variant="contained" color="primary" onClick={fetchVehInfoDocs} style={{marginLeft:theme.spacing(2), marginTop:theme.spacing(1)}}>
          Αναζήτηση
         </Button>
    </section>}

    <section className={classes.cart}>
     
      {showdetails === false && <div className={classes.container}>

        <h1>Καταχωρημένα Οχήματα</h1>
        {isloading===true && <CircularProgress />}
 
        <DataGrid rows={vehinfodoclist} columns={VehDocListColumns} getRowId={getRowId} density={'compact'}
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
        }}
        pageSizeOptions={[25, 50]}
        disableColumnMenu        
        checkboxSelection={false}   
        disableMultipleRowSelection={true}
        onRowSelectionModelChange = {(rowSelectionModel, details) => {
        }}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          columnsManagement: {
            toggleAllMode: 'filteredOnly',          
          },       
          filterPanel: {
            disableAddFilterButton: true,
            disableRemoveAllButton: true,
          },
          toolbar: {printOptions: { disableToolbarButton: true },csvOptions: { disableToolbarButton: true },}
        }} 
        />
      </div> }

    {showdetails === true && <div className={classes.container}>
      <VehicleInfoDocForm mode={VehInfodocFromModeEnum.VIEW} data={vehinfodoc} cbf={handleCloseDetails}/>
    </div> }

    </section>

    </>)
}


function NewVehicleCustomerInfo(props: VehicleCustomerInfoProps) {
  if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log("====== ********* JS NewVehicleCustomerInfo=, starts with prop.mode=",props.mode)
   let auth = useAuth();
    
  const [asuinfo, Setasuinfo]=React.useState({
      WEBSERVICE: 0,
      bu: 0,
      buname: "",
      trdr: 0,
      trdbame: "",
      trdbranch: 0,
      trdbrnname: "",
      trdafm: "",
      trdemail: "",
      whs: "",
      accesslevel: 0
  })
  const [vininfo, Setvininfo]=React.useState(vininfoExample)
  const [isLoading, setIsLoading]= React.useState(true)
  const [isposting, setIsposting]=React.useState(false)

  const [vehcustinfoconfig, setVehcustinfoconfig]=React.useState<VehCustInfoConfigType|null>(InitialVehCustInfoCfg)

  const { vehCustInfoState, setVehCustInfoContext, resetVehCustInfoContext,getVehCustInfoContext } = React.useContext(VehCustInfoContext)!;

  const [vehcustInfo, setVehcustInfo] = React.useState( getSessionVehCustInfoData() )

    
  const Demo = styled('div')(({ theme }) => ({
    backgroundColor: (theme.vars || theme).palette.background.paper,
  }));

  function fsetVehcustinfostate(source:Object){
    console.log("==* function setVehcustinfostate called with source=",source)
    const copywcst = Object.assign({}, vehcustInfo);
    const returnedTarget = Object.assign(copywcst, source);
    console.log("==* function setVehcustinfostate called, new vehcustinfostate will be=",returnedTarget)
      //   // state variable
    setVehcustInfo(returnedTarget)
      //   // store to session storage
    setVehCustInfoContext(returnedTarget)
  }

  React.useEffect(()=>{
      console.log('=JS VehicleCustomerInfo=, useeffect[] called...')
      auth.userData.userinfo?.bus?.forEach( (obu:any) =>{
        console.log('=JS VehicleCustomerInfo=, VehicleCustomerInfo useeffect[] obu=',obu)
        if(`${obu.bu}`===process.env.REACT_APP_AFTERSBU) {
          Setasuinfo({
            WEBSERVICE: obu.WEBSERVICE,
            bu:  obu.bu,
            buname:  obu.buname,
            trdr:  obu.trdr,
            trdbame:  obu.trdbame,
            trdbranch: obu.trdbranch,
            trdbrnname:  obu.trdbrnname,
            trdafm:  obu.trdafm,
            trdemail:  obu.trdemail,
            whs:  obu.whs,
            accesslevel:  obu.accesslevel
          })         
        }
      })
      if(props.mode==='view'){
        // handle view mode
        console.log('=JS VehicleCustomerInfo=, useeffect[] handling view mode...')
      } else if(props.mode==='edit'){
        // handle edit mode
        console.log('=JS VehicleCustomerInfo=, useeffect[] handling edit mode...')
      } else if(props.mode==='create'){
        // handle create mode
        console.log('=JS VehicleCustomerInfo=, useeffect[] handling create mode...')
      }
  },[])
    
  const handleNext = () => {
        if(props.mode!=='create') {console.log(`handleNext return, mode is ${props.mode} not create`); return;}

        // malaguti: VB4ET9009NY000207
        /* const steps = [
          0 'Πλαίσιο',  
          1 'Στοιχεία Πελάτη',
          2 'Αποθήκευση', 
          3 'Επισύναψη φωτό'
        ];
       */
      let canNext=true;

      /* in adding VIN */
      if(vehcustInfo.activeStep==0){
        if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log('handleNext from 0,  asuinfo',asuinfo)
        if(vehcustInfo.vin.length<17 || vehcustInfo.vin.trim()=="") {alert('vin empty or wrong');return;}
        // ????????? if(!isvinok) {alert('!isvinok');return;}
        if(`${asuinfo.bu}`!==process.env.REACT_APP_AFTERSBU || asuinfo.trdr<=0 ) {alert('Bad user information');return;}

        let usercode = auth.userData.username
        let token = auth.userData.token
        let postdata = {
          service: "getvinforwarrinfo", 
          usercode: usercode,
          vin: vehcustInfo.vin,
          clientid: token,
          trdr: asuinfo.trdr,
          trdbranch:asuinfo.trdbranch,
          accesslevel: asuinfo.accesslevel,
          userid: auth.userData.userid,
          webservice: asuinfo.WEBSERVICE, 
          bu: asuinfo.bu
        }
        let body = JSON.stringify(postdata)
        const ms = Date.now();
        let basename=returnBasenameUrl()
        let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
          body: body , cache: "no-store"
        })
        .then((response) =>  {
          if (!response.ok) return {} 
          else return response.json()
        })
        .then((data:any) => {
          // console.log(" PrAvOrd fetch Pr AV then ... data=",data)
          const isSuccessVehInfoResponse = (data: any): data is IVehWarrInfoResponse =>
            typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
          if (isSuccessVehInfoResponse(data) && data.success!==true)
          {
            alert('Η εύρεση πλαισίου απέτυχε.')
          }
          else {
            // console.log("data.hasOwnProperty('totalcount')",data.hasOwnProperty('totalcount'),"typeof data.totalcount",typeof data.totalcount)
            if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && typeof data.data === 'object'){
      
              if( data.totalcount<=0) {
                alert('Η εύρεση πλαισίου απέτυχε (query return empty, non existing vin')
              }
              else {
                if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log('handleNext vin info=', data.data[0])
                // Setvininfo({
                //   vehid: data.data[0].vehid,
                //   vin: data.data[0].vin,
                //   vehname: data.data[0].vehname,
                //   vehname2: data.data[0].vehname2,
                //   brandid: data.data[0].brandid,
                //   modelid: data.data[0].modelid,
                //   brandcode: data.data[0].brandcode,
                //   modelcode: data.data[0].modelcode,
                //   brandname: data.data[0].brandname,
                //   modelname: data.data[0].modelname,
                //   vehdocid: data.data[0].vehdocid
                // })
                if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log("=JS VehicleCustomerInfo=, handleNext from 0, setting next step")

                if(data.data[0].vehdocid>0){
                  canNext=false
                  alert('Υπάρχει καταχωρημένο έγγραφο για αυτό το VIN')
                }
                else {
                  Setvininfo({
                  vehid: data.data[0].vehid,
                  vin: data.data[0].vin,
                  vehname: data.data[0].vehname,
                  vehname2: data.data[0].vehname2,
                  brandid: data.data[0].brandid,
                  modelid: data.data[0].modelid,
                  brandcode: data.data[0].brandcode,
                  modelcode: data.data[0].modelcode,
                  brandname: data.data[0].brandname,
                  modelname: data.data[0].modelname,
                  vehdocid: data.data[0].vehdocid
                  })
                  fsetVehcustinfostate({activeStep: vehcustInfo.activeStep+1})
                }
              }
            }
            else {
              alert('Η εύρεση πλαισίου δεν είχε αποτέλεσμα. Ο κωδικός δεν υπάρχει (query return empty, non existing vin')
            }
          }
        }) 
        return
      }


      /* in customer data */
      if(vehcustInfo.activeStep==1){
        fsetVehcustinfostate({activeStep: vehcustInfo.activeStep+1})
      }

      /* in saving */
      if(vehcustInfo.activeStep==2){
        // console.log('"=JS WarrantyClaim=, handleNext, from  3,  asuinfo',asuinfo, "warrclaimdocid",warrclaimdocid)
        if(vehcustInfo.vehcustinfodocid<=0) {
          console.log(`step==4 ${vehcustInfo.activeStep} and vehcustinfodocid<=0 ${vehcustInfo.vehcustinfodocid} return`); 
          return; 
        };
        // setActiveStep((prevActiveStep) => prevActiveStep + 1);
        fsetVehcustinfostate({activeStep: vehcustInfo.activeStep+1})
      }

      /* in uploading photos */
      if(vehcustInfo.activeStep === 3){
        handleReset()
      }

      // setSkipped(newSkipped);
  };
    
  const handleBack = () => {
      if(vehcustInfo.activeStep>=2 && vehcustInfo.vehcustinfodocid>0) {console.log(`step>=2 ${vehcustInfo.activeStep} and vehcustinfodocid>0 ${vehcustInfo.vehcustinfodocid} return`); return; }
      else {
        // setActiveStep((prevActiveStep) => prevActiveStep - 1);
        fsetVehcustinfostate({activeStep: vehcustInfo.activeStep-1})
      }
  };

  const handleReset = () => {

      setIsLoading(true)
      setIsposting(false)
  
      Setvininfo(vininfoExample)

      fsetVehcustinfostate({...initialVehCustInfoContextState, warrdate: dayjs(new Date()).toJSON() })
      resetVehCustInfoContext()

      setVehcustinfoconfig(InitialVehCustInfoCfg)

      // const { vehCustInfoState, setVehCustInfoContext, resetVehCustInfoContext,getVehCustInfoContext } = React.useContext(VehCustInfoContext)!;
      // const [vehcustInfo, setVehcustInfo] = React.useState( getSessionVehCustInfoData() )
    
  };

  function vinChanged(pvin:string){
    fsetVehcustinfostate({vin: pvin})
  }

  function postVehcustinfoData(){
      // let postdata:Object={}
      if(vehcustInfo.vehcustinfodocid>0){
        console.log(`postVehcustinfoData return, vehcustinfodocid is ${vehcustInfo.vehcustinfodocid} >0, no post allowed`);
        return;
      }
      if(vehcustInfo.vin.length<17 || vehcustInfo.vin.trim()=="") {alert('vin empty or wrong');return;}
      if(`${asuinfo.bu}`!==process.env.REACT_APP_AFTERSBU || asuinfo.trdr<=0 ) {alert('Bad user information');return;}
      var datedayjs = dayjs(vehcustInfo.saledate)
      if(!dayjs.isDayjs(datedayjs)){alert('Εισάγετε σωστή ημερομηνία αγοράς');return;}
      /* {"activeStep":2,"vehcustinfodocid":0,"vehcustinfodoccode":"","vin":"VB4ET9009NY000207",
      "allready_exists":false,"saledate":"2026-02-23T18:42:11.184Z","comments":"","custname":"τστυ","custaddr":"δδδ","custzip":"14121","custcity":"222",
      "custcountry":"Ελλάδα","custmobile":"2222","custemail":"222",
      "vindata":{
        "vehid":0,"vin":"","vehname":"","vehname2":"","brandid":0,"modelid":0,"brandcode":"","modelcode":"","brandname":"","modelname":""},
      "warrdate":"2026-02-23T18:42:17.969Z"} */
      try{
        setIsposting(true)
        let usercode = auth.userData.username
        let token = auth.userData.token
        let postdata = {
          service: "postvehcustinfodoc", 
          usercode: usercode,
          clientid: token,
          trdr: asuinfo.trdr,
          trdbranch:asuinfo.trdbranch,
          accesslevel: asuinfo.accesslevel,
          userid: auth.userData.userid,
          webservice: asuinfo.WEBSERVICE, 
          bu: asuinfo.bu,
          vehcustinfodocid: vehcustInfo.vehcustinfodocid,
          vehcustinfodoccode: vehcustInfo.vehcustinfodoccode,
          vin: vehcustInfo.vin,
          saledate: datedayjs.format("DD/MM/YYYY"),
          comments: vehcustInfo.docremarks,
          custname: vehcustInfo.custname,
          custaddr: vehcustInfo.custaddr,
          custzip: vehcustInfo.custzip,
          custcity: vehcustInfo.custcity,
          custcountry: vehcustInfo.custcountry,
          custmobile: vehcustInfo.custmobile,
          custemail: vehcustInfo.custemail,

        }  ;
        console.log("postVehcustinfoData postdata", postdata);

        let body = JSON.stringify(postdata)
        const ms = Date.now();
        let basename=returnBasenameUrl()
        let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
        console.log("postVehcustinfoData post url", url);

        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
          body: body , 
          cache: "no-store"
       })
       .then((response) =>  {
          if (!response.ok) return {} 
          else return response.json()
       })
       .then((data:any) => {
          console.log("postVehcustinfoData response data", data);
          const isSuccessPosVehcustinfoResponse = (data: any): data is newVehinfoResponseType =>
           typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
          if (isSuccessPosVehcustinfoResponse(data) && data.success) {
            //alert('Η καταχώριση πληροφοριών οχήματος ήταν επιτυχής. (posting vehicle data succeeded)')
            if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && typeof data.data === 'object'){
               if( data.totalcount<=0) {
                  alert('Η καταχώριση πληροφοριών οχήματος δεν επέστρεψε αποτέλεσμα. Προσπαθήστε ξανά σε λίγο (query failed, try again later)')
               }
               else {
                // Handle successful response with data
                // setVehCustInfoContext({...vehCustInfoState, vehcustinfodocid:data.data.infodocid,
                //   vehcustinfodoccode: data.data.infodoccode, activeStep: 3
                // })
                // setVehcustInfo({...vehcustInfo, activeStep: 3})
                /*  vehCustInfoState.activeStep = 3
                {"success":true,"reply":"postvehcustinfodoc_reply","totalcount":1,"procstep":85,
                "data":{"infodocid":73576,"infodocnumber":3,"infodoccode":"\u03a0\u039b\u039f\u03a7000003"}
                } */
                fsetVehcustinfostate({vehcustinfodocid:data.data.infodocid, vehcustinfodoccode: data.data.infodoccode})
                alert('Η καταχώριση πληροφοριών οχήματος ολοκληρώθηκε.')
              }
            }
          } else {
            alert('Η καταχώριση πληροφοριών οχήματος απέτυχε. (posting vehicle data failed, try again later)')
          }
        })
      }
      catch(e){
        alert('Η καταχώριση πληροφοριών οχήματος απέτυχε.(runtimeerr) (posting vehicle data failed, try again later)')
      }
      finally{
        setIsposting(false)
        // handleReset()
      }
  }

    /* mtrl=56727 {"activeStep":2,"vehcustinfodocid":0,"vehcustinfodoccode":"","vin":"VB4ET9009NY000207",
    "allready_exists":false,"saledate":"2026-02-23T18:42:11.184Z","comments":"","custname":"τστυ","custaddr":"δδδ","custzip":"14121","custcity":"222",
    "custcountry":"Ελλάδα","custmobile":"2222","custemail":"222",
    "vindata":{
      "vehid":0,"vin":"","vehname":"","vehname2":"","brandid":0,"modelid":0,"brandcode":"","modelcode":"","brandname":"","modelname":""},
    "warrdate":"2026-02-23T18:42:17.969Z"} */

  let disablePost = vehcustInfo.vehcustinfodocid>0 || isposting===true

  if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log("=JS VehicleCustomerInfo=, vehCustInfoState=", vehCustInfoState, "vehcustInfo=", vehcustInfo)

  return(    
      <Box sx={{ width: '100%' }}>
        <Stepper activeStep={vehcustInfo.activeStep}>
          {steps.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: {
              optional?: React.ReactNode;
            } = {};
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {vehcustInfo.activeStep === steps.length ? (
          <Alert variant="outlined" severity="info">
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          </Alert>
        ) : (
          
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 1, justifyContent: 'space-between' }}>

              <div >
              <Typography sx={{mr:2}}>Βήμα {vehcustInfo.activeStep + 1} {stepsmessage[vehcustInfo.activeStep]}</Typography>
              </div>

              <div>
              <Button onClick={handleReset}>
                Reset
              </Button>
              </div>

              <div>
              <Button
                color="inherit"
                disabled={vehcustInfo.activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                Back
              </Button>
              </div>
              {/* <Box sx={{ flex: '1 1 auto' }} > */}
              {/* {isStepOptional(warrclaimstate.activeStep) && (
                <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                  Skip
                </Button>
              )} */}

              <div>
              <Button onClick={handleNext}>
                {vehcustInfo.activeStep === steps.length - 1 ? 'Finish' : 'Next'}
              </Button>
              </div>

            </Box>

        )}

        {vehcustInfo.activeStep === 0 && (
            <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }} noValidate={true} autoComplete="off" >
              <Paper >
              <TextField
                required
                id="vin-required"
                label="Πλαίσιο"
                value={vehcustInfo.vin}
                variant="standard"
                onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  vinChanged(event.target.value); }}
              />
              </Paper>
            </Box>
        ) }

        {vehcustInfo.activeStep === 1 && (
          <>
              <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" >
              <Paper elevation={1} sx={{m:2,p:2}}>
              <Typography variant="subtitle2" component="span"> Πλαίσιο: </Typography>
              <Typography variant="body1" component="span">{vehcustInfo.vin} </Typography>
              <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography>
              </Paper>
            </Box>

          <Paper>
            
          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1,  maxWidth: '90%' } }} noValidate autoComplete="off" >
              <TextField  id="custname"  label="Ονοματεπώνυμο"
                value={vehcustInfo.custname}
                variant="standard"
                size="small"
                fullWidth
                required={vehcustinfoconfig?.custname.required}
                onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                  //setFaultCode(event.target.value); 
                  fsetVehcustinfostate({custname: event.target.value })
                }}
              />
          </Box>    
              

          {/* <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" > */}
            <Grid container spacing={2}>
            <Grid size={8}>
              <TextField  id="custaddr"  label="Διεύθυνση"
                value={vehcustInfo.custaddr}
                variant="standard"
                size="small"
                fullWidth
                required={vehcustinfoconfig?.custaddr.required}
                sx={{marginLeft:1}}
                onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                  //setFaultCode(event.target.value); 
                  fsetVehcustinfostate({custaddr: event.target.value })
                }}
              />             
            </Grid>
            <Grid size={4}>
              <TextField  id="custzip"  label="Τ.Κ."
                value={vehcustInfo.custzip}
                variant="standard"
                size="small"
                fullWidth
                required={vehcustinfoconfig?.custzip.required}
                onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                  //setFaultCode(event.target.value); 
                  fsetVehcustinfostate({custzip: event.target.value })
                }}
              />             
            </Grid>
            </Grid>

            <Grid container spacing={2}>
            <Grid size={6}>
              <TextField  id="custcity"  label="Πόλη"
                value={vehcustInfo.custcity}
                variant="standard"
                size="small"
                fullWidth
                required={vehcustinfoconfig?.custcity.required}
                sx={{marginLeft:1}}
                onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                  //setFaultCode(event.target.value); 
                  fsetVehcustinfostate({custcity: event.target.value })
                }}
              />             
            </Grid>
            <Grid size={6}>
              <TextField  id="custcountry"  label="Χώρα"
                value={vehcustInfo.custcountry}
                variant="standard"
                size="small"
                fullWidth
                required={vehcustinfoconfig?.custcountry.required}
                onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                  //setFaultCode(event.target.value); 
                  fsetVehcustinfostate({custcountry: event.target.value })
                }}
              />             
            </Grid>
            </Grid>

            <Grid container spacing={2}>
            <Grid size={6}>
              <TextField  id="custmobile"  label="Κινητό/Τηλ."
                value={vehcustInfo.custmobile}
                variant="standard"
                size="small"
                fullWidth
                required={vehcustinfoconfig?.custmobile.required}
                sx={{marginLeft:1}}
                onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                  //setFaultCode(event.target.value); 
                  fsetVehcustinfostate({custmobile: event.target.value })
                }}
              />             
            </Grid>
            <Grid size={6}>
              <TextField  id="custemail"  label="e-mail"
                value={vehcustInfo.custemail}
                variant="standard"
                size="small"
                fullWidth
                required={vehcustinfoconfig?.custemail.required}
                onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                  //setFaultCode(event.target.value); 
                  fsetVehcustinfostate({custemail: event.target.value })
                }}
              />             
            </Grid>
            </Grid>

            <Grid container spacing={2}>
            <Grid size={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateField label="ημερομηνία αγοράς"  size="small"
              value={dayjs(vehcustInfo.saledate)}
              onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
              onChange={ (newValue) =>  fsetVehcustinfostate({ saledate: newValue?.toJSON() }) }
              format="DD/MM/YYYY"
            />
            </LocalizationProvider>
            </Grid>
            </Grid>

            <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" >
            <div>
            <TextField fullWidth sx={{ m: 1 }} variant="standard"  size="small" id="doc-remarks"   label="Σχόλια"
              multiline rows={4} value={vehcustInfo.docremarks}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>  fsetVehcustinfostate( { docremarks: event.target.value }) }  />
            </div>
            </Box>

          </Paper></>
        )}

        {vehcustInfo.activeStep === 2 && (
          <>
          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate={true} autoComplete="off" >
                <Paper elevation={1} sx={{m:2,p:2}}>
                  <div>
                  <Typography variant="subtitle2" component="span"> Πλαίσιο: </Typography>
                  <Typography variant="body1" component="span">{vehcustInfo.vin} </Typography>
                  <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography>
                  </div>
                  <div>
                    <Typography variant="subtitle2" component="span"> Πελάτης: </Typography>
                    <Typography variant="body1" component="span">{vehcustInfo.custname} </Typography>
                    <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography>
                  </div>
                </Paper>
          </Box>

          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" >
            <Paper elevation={1} sx={{m:2,p:2}}>
                <Button variant="contained" endIcon={<SendIcon />} loading={isposting} disabled={disablePost}
                  onClick={(e)=>{postVehcustinfoData()}}>Αποστολη</Button>
                <div>
                  <Typography variant="body2" component="span">Μετά την αποστολή (καταχώριση) δεν επιτρέπονται αλλαγές. Πρέπει μόνο να προσθέσετε φωτογραφία της άδειας κυκλοφορίας στο επόμενο βήμα.</Typography>
                </div>
                <div>
                { (vehcustInfo.vehcustinfodocid>0) ? (<Typography variant="body1" component="span">
                  Επιτυχής καταχώριση. Κωδικός Εγγράφου:{` ${vehcustInfo.vehcustinfodoccode}`}
                  </Typography>) : (<Typography variant="body1" component="span">
                    {` `}
                  </Typography>)
                }
                </div>
            </Paper>
          </Box>

        </>) }

        {vehcustInfo.activeStep === 3 && vehcustInfo.vehcustinfodocid>0 && (
          <>
          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" >
                <Paper elevation={1} sx={{m:2,p:2}}>
                  <div>
                  <Typography variant="subtitle2" component="span"> Πλαίσιο: </Typography>
                  <Typography variant="body1" component="span">{vehcustInfo.vin} </Typography>
                  <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography>
                  </div>
                  <div>
                  <Typography variant="subtitle2" component="span"> Πελάτης: </Typography>
                  <Typography variant="body1" component="span">{vehcustInfo.custname} </Typography>
                  <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography>
                  </div>
                  <div>
                  { (vehcustInfo.vehcustinfodocid>0) ? (<Typography variant="body1" component="span">
                    Κωδικός Εγγράφου:{` ${vehcustInfo.vehcustinfodoccode}`}
                    </Typography>) : (<Typography variant="body1" component="span">
                      {` `}
                    </Typography>)
                  }
                  </div>
                </Paper>
          </Box>
          <UploadImagesV2 targetdocid={vehcustInfo.vehcustinfodocid} clientid={auth.userData.token} usercode={auth.userData.username} 
          nameprefix="vhreg" namepostfix="attachm" namepart={vehcustInfo.vin} uplsource="b2bksrvehregistration"  />

          </>
        )}

        {vehcustInfo.activeStep === steps.length ? (
          <Alert variant="outlined" severity="info">
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          </Alert>
        ) : (

          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, justifyContent: 'space-between' }}>

          <div >
          <Typography sx={{mr:2}}>{'   '}</Typography>
          </div>

            <div>
              <Button onClick={handleReset}>
                Reset
              </Button>
            </div>

          <div>
          <Button
            color="inherit"
            disabled={vehcustInfo.activeStep === 0}
            onClick={handleBack}
            sx={{ mr: 1 }}
          >
            Back
          </Button>
          </div>
          {/* <Box sx={{ flex: '1 1 auto' }} > */}
          {/* {isStepOptional(warrclaimstate.activeStep) && (
            <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
              Skip
            </Button>
          )} */}
          <div>
          <Button onClick={handleNext}>
            {vehcustInfo.activeStep === steps.length - 1 ? 'Finish' : 'Next'}
          </Button>
          </div>

        </Box>
        )}

        <div>
          {/* {`DEBUG vin=[${warrclaimState.vin}] warrclaimdocid=[${warrclaimState.warrclaimdocid}] warrclaimdoccode=[${warrclaimState.warrclaimdoccode}] prrows=[${warrclaimState.prrows.length}]`}
          {` labrows=[${warrclaimState.labrows.length}] warrdate=[${warrclaimState.warrdate}]`}
        */}
        {'   '}
        </div>
      </Box>
  )

}

function VehicleInfoDocForm(props: VehicleInfoDocFormProps) {

  if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log("====== ********* JS VehicleInfoDocForm=, starts with props=",props)
   let auth = useAuth();

  const [isLoading, setIsLoading]= React.useState(true)
  const [isposting, setIsposting]=React.useState(false)
  const [vehcustInfo, setVehcustInfo] = React.useState(props.data || InitialVehCustInfoDoc)
  const [vehcustinfoconfig, setVehcustinfoconfig]=React.useState<VehCustInfoConfigType|null>(InitialVehCustInfoCfg)
  const [asuinfo, Setasuinfo]=React.useState({
      WEBSERVICE: 0,
      bu: 0,
      buname: "",
      trdr: 0,
      trdbame: "",
      trdbranch: 0,
      trdbrnname: "",
      trdafm: "",
      trdemail: "",
      whs: "",
      accesslevel: 0
  })
  
  const Demo = styled('div')(({ theme }) => ({
    backgroundColor: (theme.vars || theme).palette.background.paper,
  })); 
  function fsetVehcustinfostate(source:Object){
    console.log("==* function setVehcustinfostate called with source=",source)
    const copywcst = Object.assign({}, vehcustInfo);
    const returnedTarget = Object.assign(copywcst, source);
    console.log("==* function setVehcustinfostate called, new vehcustinfostate will be=",returnedTarget)
      //   // state variable
    setVehcustInfo(returnedTarget)
      //   // store to session storage
  }

  let disablePost = true; // vehcustInfo.vehcustinfodocid>0 || isposting===true

  return(    
    <Box sx={{ width: '100%' }}>

      <h1>Καταχωρημένο Όχημα (Έγγραφο {vehcustInfo.doccode})</h1>

      <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }} noValidate={true} autoComplete="off" >
          <Paper >
          <TextField
            required
            id="vin-required"
            label="Πλαίσιο"
            value={vehcustInfo.vin}
            variant="standard"
            slotProps={{
              input: { readOnly: (props.mode===VehInfodocFromModeEnum.VIEW)?true:false }
            }}
          />
          </Paper>
      </Box>

      <Paper>
            
        <Box component="form" sx={{ '& .MuiTextField-root': { m: 1,  maxWidth: '90%' } }} noValidate autoComplete="off" >
            <TextField  id="custname"  label="Ονοματεπώνυμο"
              value={vehcustInfo.custname}
              variant="standard"
              size="small"
              fullWidth
              slotProps={{
                input: { readOnly: (props.mode===VehInfodocFromModeEnum.VIEW)?true:false }
              }}  />
        </Box>

        <Grid container spacing={2}>
            <Grid size={8}>
              <TextField  id="custaddr"  label="Διεύθυνση"
                value={vehcustInfo.custaddr}
                variant="standard"
                size="small"
                fullWidth
                required={vehcustinfoconfig?.custaddr.required}
                sx={{marginLeft:1}}
                slotProps={{
                    input: { readOnly: (props.mode===VehInfodocFromModeEnum.VIEW)?true:false }
                }}  />             
            </Grid>
            <Grid size={4}>
              <TextField  id="custzip"  label="Τ.Κ."
                value={vehcustInfo.custzip}
                variant="standard"
                size="small"
                fullWidth
                required={vehcustinfoconfig?.custzip.required}
               slotProps={{
                    input: { readOnly: (props.mode===VehInfodocFromModeEnum.VIEW)?true:false }
                }}                />             
            </Grid>
        </Grid>

        <Grid container spacing={2}>
            <Grid size={6}>
                <TextField  id="custcity"  label="Πόλη"
                  value={vehcustInfo.custcity}
                  variant="standard"
                  size="small"
                  fullWidth
                  required={vehcustinfoconfig?.custcity.required}
                  sx={{marginLeft:1}}
                  slotProps={{
                    input: { readOnly: (props.mode===VehInfodocFromModeEnum.VIEW)?true:false }
                  }}
                />             
            </Grid>
            <Grid size={6}>
                <TextField  id="custcountry"  label="Χώρα"
                  value={vehcustInfo.custcountry}
                  variant="standard"
                  size="small"
                  fullWidth
                  required={vehcustinfoconfig?.custcountry.required}
                  slotProps={{
                    input: { readOnly: (props.mode===VehInfodocFromModeEnum.VIEW)?true:false }
                  }}
                />             
            </Grid>
        </Grid>

        <Grid container spacing={2}>
            <Grid size={6}>
                <TextField  id="custmobile"  label="Κινητό/Τηλ."
                  value={vehcustInfo.custmobile}
                  variant="standard"
                  size="small"
                  fullWidth
                  required={vehcustinfoconfig?.custmobile.required}
                  sx={{marginLeft:1}}
                  slotProps={{
                    input: { readOnly: (props.mode===VehInfodocFromModeEnum.VIEW)?true:false }
                  }}
                />             
            </Grid>
            <Grid size={6}>
                <TextField  id="custemail"  label="e-mail"
                  value={vehcustInfo.custemail}
                  variant="standard"
                  size="small"
                  fullWidth
                  required={vehcustinfoconfig?.custemail.required}
                  slotProps={{
                    input: { readOnly: (props.mode===VehInfodocFromModeEnum.VIEW)?true:false }
                  }}
                />             
            </Grid>
        </Grid>

        <Grid container spacing={2}>
            <Grid size={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateField label="ημερομηνία αγοράς"  size="small"
                value={dayjs(vehcustInfo.saldate)}
                readOnly={props.mode===VehInfodocFromModeEnum.VIEW}
                format="DD/MM/YYYY"
              />
              </LocalizationProvider>
            </Grid>
        </Grid>

        <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" >
            <div>
              <TextField fullWidth sx={{ m: 1 }} variant="standard"  size="small" id="doc-remarks"   label="Σχόλια"
                multiline rows={4} value={vehcustInfo.remarks}                   
                slotProps={{
                    input: { readOnly: (props.mode===VehInfodocFromModeEnum.VIEW)?true:false }
                  }}
                  /> 
            </div> 
        </Box>
    
        <Box>
        <Typography>Αποθηκευμένη εικόνα/pdf:</Typography>
        <ol>
            {[...vehcustInfo.attachements].map((f, i) => (
                <li key={i}><a href={`${f.file}`} target="_blank">{`${f.originalfile}`}</a></li>
            ))}
        </ol>
        </Box>

      </Paper>

      <Grid container spacing={2}>
      <Grid size={10}>
        <Typography>Για αντικατάσταση αποθηκευμένης εικόνας/pdf ...</Typography>
        <UploadImagesV2 targetdocid={vehcustInfo.docid} clientid={auth.userData.token} usercode={auth.userData.username} 
          nameprefix="vhreg" namepostfix="attachm" namepart={vehcustInfo.vin} uplsource="b2bksrvehregistration" />
      </Grid>
      <Grid size={2}>
        <Button variant="contained" endIcon={<StopCircleIcon />} color="warning" onClick={props.cbf}>
          κλεισιμο
        </Button>
      </Grid>
      </Grid>
      <div>
          {/* {`DEBUG vin=[${warrclaimState.vin}] warrclaimdocid=[${warrclaimState.warrclaimdocid}] warrclaimdoccode=[${warrclaimState.warrclaimdoccode}] prrows=[${warrclaimState.prrows.length}]`}
          {` labrows=[${warrclaimState.labrows.length}] warrdate=[${warrclaimState.warrdate}]`}
        */}
      {'   '}
      </div>

    </Box>
  )
}